<template>
  <UiNarrowContainer>
    <CartPage />
  </UiNarrowContainer>
</template>

<script setup lang="ts">
const { t } = useI18n();

useHead({
  title: t('cart.cart'),
});

definePageMeta({
  layout: 'colored',
});
</script>
